import type { Organization, UnitLimitType } from '~/types.ts'

export function getActiveUnitLimit(organization: Organization, limitType: UnitLimitType): number {
  const limit = organization[limitType]
  if (limit === null || limit === undefined) {
    return Infinity
  }

  return limit
}

export function getUnitLimitUsage(organization: Organization, limitType: UnitLimitType): number {
  const usage = organization.unit_limit_usage?.[limitType]
  if (usage !== undefined) {
    return Math.max(0, usage)
  }

  return 0
}

export function getUnitLimitPercentage(organization: Organization, limitType: UnitLimitType): number {
  const activeLimit = getActiveUnitLimit(organization, limitType)
  if (activeLimit === Infinity) {
    return 0
  }

  const usage = getUnitLimitUsage(organization, limitType)
  if (activeLimit <= 0) {
    return 100
  }

  return Math.min(100, Math.round((usage / activeLimit) * 100))
}
